"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@blueprintjs/core");
var PreviewComponent = function (props) {
    var url = props.url, type = props.type;
    return (react_1.default.createElement(react_1.default.Fragment, null, type.includes('video') || type.includes('audio') ? (react_1.default.createElement("video", { style: {
            height: '100%',
            width: '100%',
            objectFit: 'contain'
        }, controls: true },
        react_1.default.createElement("source", { src: url, type: type }),
        "Your browser does not support the video tag.")) : type.includes('image') ? (react_1.default.createElement("img", { style: {
            height: '100%',
            width: '100%',
            objectFit: 'contain'
        }, src: url, onClick: function () {
            window.open(url, '_blank');
        } })) : (react_1.default.createElement("div", { style: {
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        } },
        react_1.default.createElement(core_1.Icon, { icon: 'eye-off', iconSize: 100, color: 'gray' })))));
};
exports.default = PreviewComponent;
